import {
  Box,
  Drawer,
  List,
  SvgIconTypeMap,
  useMediaQuery,
} from "@mui/material";
import { FC } from "react";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import { DRAWER_WIDTH } from "src/utils/constants";
import {
  AssignmentOutlined,
  CardMembershipOutlined,
  GroupOutlined,
  ReceiptOutlined,
  RedeemOutlined,
} from "@mui/icons-material";
import SidebarNavItem from "./SidebarNavItem";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import BoldTypography from "./BoldTypography";
import { Link } from "react-router-dom";

interface SidebarProps {
  open: boolean;
  onClose: () => void;
}

type SidebarItem = {
  label: string;
  path: string;
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
};

const items: SidebarItem[] = [
  { icon: AssignmentOutlined, label: "Orders", path: "/orders" },
  { icon: GroupOutlined, label: "Users", path: "/users" },
  {
    icon: CardMembershipOutlined,
    label: "Subscriptions",
    path: "/subscriptions",
  },
  { icon: ReceiptOutlined, label: "Invoices", path: "/invoices" },
  { icon: RedeemOutlined, label: "Redeem Requests", path: "/redeem-requests" },
];

const Sidebar: FC<SidebarProps> = ({ open, onClose }) => {
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up("lg"));

  const isOpen = lgUp || open;
  const variant = lgUp ? "permanent" : "temporary";

  const renderItems = (): JSX.Element[] => {
    return items.map(({ icon, label, path }) => {
      return (
        <SidebarNavItem key={path} label={label} icon={icon} path={path} />
      );
    });
  };

  return (
    <Drawer
      anchor="left"
      onClose={onClose}
      open={isOpen}
      variant={variant}
      sx={{ width: DRAWER_WIDTH }}
      PaperProps={{ sx: { width: DRAWER_WIDTH } }}
    >
      <Box p={3} component={Link} to="/" sx={{ textDecoration: "none" }} onClick={onClose}>
        <BoldTypography variant="h5" color="primary">
          RECOVA
        </BoldTypography>
      </Box>
      <List onClick={onClose}>{renderItems()}</List>
    </Drawer>
  );
};

Sidebar.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Sidebar;
